import {get} from 'lodash';

export default (state = {}, {coachId, teams}: any) => {
  return {
    ...state,
    allTeams: {
      ...get(state, 'allTeams', {}),
      [coachId]: teams,
    },
  };
};
